/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import moment, {MomentInput} from 'moment';
import _ from 'underscore';

import * as DateUtil from 'util/DateUtil';

function setMomentLocaleForCompact(): void {
  // Sets the locale for brevity when displaying minutes, hours, or days in the past.
  moment.updateLocale('en', {
    relativeTime: {
      past: '%s',
      s: '1s',
      ss: '%ds',
      m: '1m',
      mm: '%dm',
      h: '1h',
      hh: '%dh',
      d: '1d',
      dd: '%dd',

      // Not needed - this locale should only be used for dates in the recent past
      future: '',
      M: '',
      MM: '',
      y: '',
      yy: '',
    },
  });
}

function resetMomentLocale(): void {
  moment.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
    },
  });
}

interface FormatOptions {
  days: number;
  showYear: boolean;
  showTime: boolean;
  showWeekday: boolean;
  compact: boolean;
}

/**
 * Formats date into either relative time or a human readable format
 *
 * If date is within a minute of the current time, returns either 'now' or 'just now'.
 * If date is within formatOptions.days (or if null, 7) days of the current time, returns a diff, e.g. 3 days
 *    ago.
 * Otherwise, returns a formatted date.
 */
function fuzzydate(date: string | MomentInput, formatOptions?: Partial<FormatOptions>): string {
  if (formatOptions == null) {
    formatOptions = {};
  }
  if (date == null) {
    throw new Error('missing comparison operator');
  }
  _.defaults(formatOptions, {
    days: 7,
    showYear: true,
    showTime: true,
    showWeekday: false,
    compact: false,
  });
  const defaultedFormatOptions: FormatOptions = formatOptions as FormatOptions;

  const now = moment();
  date = typeof date === 'string' ? new Date(date) : date;
  date = moment(date);
  const diffSeconds = now.diff(date, 'seconds');
  if (diffSeconds < 60) {
    if (!defaultedFormatOptions.compact) {
      return 'just now';
    } else {
      return 'now';
    }
  }
  const diffDays = now.diff(date, 'days');
  if (diffDays <= defaultedFormatOptions.days) {
    if (defaultedFormatOptions.compact) {
      let returnString;
      setMomentLocaleForCompact();
      try {
        returnString = date.fromNow();
      } finally {
        resetMomentLocale();
      }
      return returnString;
    } else {
      return date.fromNow();
    }
  }
  return DateUtil.readableTime(date.toDate(), {
    showYear: defaultedFormatOptions.showYear,
    showTime: defaultedFormatOptions.showTime,
    showWeekday: defaultedFormatOptions.showWeekday,
  });
}

resetMomentLocale();
export default fuzzydate;
